module.exports = __webpack_public_path__ + "tail-shape.svg?98322da7b9cd249b4fa354de329faa85";